import { render } from "./EventCard.vue?vue&type=template&id=ed9e7ba6&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=ed9e7ba6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ed9e7ba6"

export default script